import React, { useState, useMemo } from 'react';
import { useGameStore, selectCharsInPool } from '../store/gameStore';
import Tile from './Tile';

const TilePool = () => {
  const [isDragOver, setIsDragOver] = useState(false);
  const { tileSize, returnTileToPool, currentSentenceIndex, currentLessonIndex, shuffleNonce } = useGameStore();
  const charsInPool = useGameStore(selectCharsInPool);
  
  // Stable shuffle order per sentence; also re-shuffles when the user clicks
  // the Shuffle button (which bumps `shuffleNonce`).
  const shuffleOrder = useMemo(() => {
    const order = {};
    const indices = charsInPool.map(t => t.origIndex);
    const shuffled = [...indices].sort(() => Math.random() - 0.5);
    shuffled.forEach((origIndex, position) => { order[origIndex] = position; });
    return order;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLessonIndex, currentSentenceIndex, shuffleNonce]);
  
  const pool = [...charsInPool].sort(
    (a, b) => (shuffleOrder[a.origIndex] ?? 0) - (shuffleOrder[b.origIndex] ?? 0)
  );
  
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };
  
  const handleDragLeave = () => {
    setIsDragOver(false);
  };
  
  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    returnTileToPool();
  };
  
  const handleClick = () => {
    returnTileToPool();
  };
  
  const poolStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: `${Math.max(6, tileSize * 0.14)}px`,
    minHeight: '64px',
    padding: '16px',
    background: '#1e293b',
    border: isDragOver ? '2px dashed #6366f1' : '2px dashed #334155',
    borderRadius: '16px',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'border-color 0.2s, background 0.2s',
  };
  
  const handleTileClick = (tile) => {
    const { selectTile, selectedTile: current, clearSelection } = useGameStore.getState();
    
    if (current?.tile?.origIndex === tile.origIndex && current?.from === 'pool') {
      clearSelection();
    } else {
      selectTile(tile, 'pool');
    }
  };
  
  return (
    <div>
      <div className="section-label">Available characters — drag down or tap to select</div>
      <div 
        className={`tile-pool ${isDragOver ? 'drag-over' : ''}`}
        style={poolStyle}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={handleClick}
      >
        {pool.map((tile) => (
          <Tile
            key={tile.origIndex}
            tile={tile}
            location="pool"
            onClick={() => handleTileClick(tile)}
          />
        ))}
        {pool.length === 0 && (
          <div style={{ color: '#64748b', padding: '20px' }}>
            All characters placed!
          </div>
        )}
      </div>
    </div>
  );
};

export default TilePool;
